import { Select } from '@travellegacy/nexops-design-system';

interface QuarterSelectorProps {
  value: number;
  onChange: (value: number) => void;
  label?: string;
  error?: string;
}

const quarterOptions = [
  { value: 1, label: 'Q1 (Jan - Mar)' },
  { value: 2, label: 'Q2 (Abr - Jun)' },
  { value: 3, label: 'Q3 (Jul - Set)' },
  { value: 4, label: 'Q4 (Out - Dez)' },
];

/**
 * Componente para selecionar trimestre (Q1, Q2, Q3, Q4)
 */
export function QuarterSelector({ value, onChange, label, error }: QuarterSelectorProps) {
  return (
    <Select
      label={label || 'Trimestre'}
      value={value.toString()}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(parseInt(e.target.value))}
      error={error}
      options={quarterOptions.map((opt) => ({
        value: opt.value.toString(),
        label: opt.label,
      }))}
    />
  );
}

/**
 * Helper para obter o trimestre atual
 */
export function getCurrentQuarter(): number {
  const month = new Date().getMonth() + 1;
  return Math.ceil(month / 3);
}

/**
 * Helper para obter o nome do trimestre
 */
export function getQuarterName(quarter: number): string {
  const option = quarterOptions.find((opt) => opt.value === quarter);
  return option?.label || `Q${quarter}`;
}
